StepController = App.loadClass 'grower::Angular/Data/PlantingRx/StepController'

class exports.ProductPlanterController extends StepController
    constructor: (@scope, @transitions, @rxLayer, @q, @seedCompanies, @products) ->
        super(@scope, @transitions)
        return if @scope.aborted

        @scope.$parent.show_fullpage = true
        @scope.disableRow = @disableRow
        @scope.selectCompany = @selectCompany
        @scope.selectBrand = @selectBrand
        @scope.loadCompanyBrands = @loadCompanyBrands
        @scope.loadBrandTreatments = @loadBrandTreatments

        @scope.$watch 'productPlanterForm.$valid', (value) =>
            @scope.$parent.setValidity(value)

        @populateRepos()

        # If we already have selections setup (we're editing, or coming
        # from the SPP with preselected hybrids...), ensure that those rows
        # have their brand and treatment lists populated
        loadBrandsAndTreatments = () =>
            for row in @scope.rx.planting_selections
                @loadCompanyBrands(row, row.company) if row.company?
                @loadBrandTreatments(row, row.brand) if row.brand?
        loadBrandsAndTreatments()
        # Handles when refreshing to here
        @scope.$on 'rx:loaded', () =>
            loadBrandsAndTreatments()

        # populate lists for the refuge row if it's set
        @addRefugeRow()
        if @scope.rx.refuge?
            row = @scope.rx.refuge
            @loadCompanyBrands(row, row.company) if row.company?
            @loadBrandTreatments(row, row.brand) if row.brand?


    ###
     * Add the default refuge row. If there's no refuge specified,
     * we add this disabled row, so people always have the option of
     * enabling and adding a refuge.
    ###
    addRefugeRow: () =>
        if not @scope.rx.refuge?
            @scope.rx.refuge =
                name: 'Refuge'
                company: null
                brand: null
                treatment: null
                refuge: true
                active: false

    ###
     * Load brands for a given company into a given row
    ###
    loadCompanyBrands: (row, company) =>
        selected = @rxLayer.selectedHybridIds()
        @products.bySeedCompany company.id, @scope.rx.fields_id, @scope.rx.crops_id, selected
        .then (response) =>
            row.products = response.data.data

    ###
     * When the user selects a brand for a row,
     * dynamically load the treatments for that brand
    ###
    loadBrandTreatments: (row, brand) =>
        @products.treatments brand.id, @scope.rx.spp_id
        .then (response) =>
            row.treatments = response.data.data
            @setDefaultTreatment(row)

    ###
     * Handles setting the default treatment for a row if there is one
     * and it's in the treatment list
    ###
    setDefaultTreatment: (row) =>
        found_treatment = null
        if row.brand.default_treatment_id? or row.brand.secondary_treatment_id?
            for tmt in row.treatments
                # If we find the secondary treatment, set found_treatment.
                # But keep going, in case we find a match for the default treatment!
                if tmt.id is row.brand.secondary_treatment_id
                    found_treatment = tmt

                # If we find the default treatment, set found_treatment
                # and then break out of the loop
                if tmt.id is row.brand.default_treatment_id
                    found_treatment = tmt
                    break

            row.treatment = found_treatment

    ###
     * When the user selects a seed company for a row,
     * unset the selected brand and treatment, and call
     * the method to load the brands for this company
    ###
    selectCompany: (row, company) =>
        row.brand = null
        row.treatment = null
        @loadCompanyBrands(row, company)

    ###
     * When the user selects a brand, handle refuge requirement
    ###
    selectBrand: (row, brand) =>
        @loadBrandTreatments(row, brand)

        # Only the primary brand's refuge requirement
        # is checked. We don't care about other rows right now
        if not row.primary
            return


    ###
     * If we want to remove the low yield product or the refuge, we can disable
     * the row, clearing selected values and setting it to inactive
    ###
    disableRow: (row) =>
        row.company = null
        row.brand = null
        row.treatment = null
        # Clear the "repos"
        row.brands = null
        row.treatments = null

        row.active = false

    ###
     * Query repositories for all relevant information.
     * If the data is already set for a give item, we probably
     * don't need to re-load it.
     *
     * The scope.repos variable *references* the parent (SidebarController)
     * repos variable, so that means that the repos will live on after
     * this step is passed / destroyed. This means that if the user
     * comes back to this step, we won't have to re-query.
    ###
    populateRepos: () =>
        @scope.$emit 'planting-rx:step-loading'

        promises = []

        if not @scope.repos.seed_companies?
            p = @seedCompanies.all crops_id: @scope.rx.crops_id
            p.then (response) =>
                @scope.repos.seed_companies = response.data.data

            promises.push(p)

        @q.all(promises).then () =>
            @scope.$emit 'planting-rx:step-ready'
